export default "__VITE_ASSET__DEr2yVTT__"